var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',{attrs:{"nav":""}},[_vm._l((_vm.items),function(item,index){return [(!_vm.isMotor)?_c('menu-item',{key:index,attrs:{"item":item}}):_vm._e()]}),_c('v-list-item',[_c('v-btn',{staticClass:"secondary",attrs:{"block":""},on:{"click":_vm.redirectLogout}},[_vm._v(_vm._s(_vm.$t('logout')))])],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }